import React, { useContext } from "react";
import styles from "./progressbar.module.scss";
import { css } from "@emotion/core";
import { UrlContext } from '../contexts/UrlContext';
import quizMetadata from '../data/json/quiz-metadata.json';

const ProgressBar = () => {

 const { answers, quiz, formSubmitted } = useContext( UrlContext );

 let completed = 0;
 
 if ( formSubmitted === true ) {
   completed = 100;
 } else if ( quiz !== '' && typeof window !== 'undefined' ) {
   let totalSteps = quizMetadata[quiz].steps;
   let currentStep = answers.length;
   completed = currentStep / totalSteps * 100;
   // TO-DO: Need to add handling for form submission = 100%
 }

  return (
    <div className={styles.progressBarContainer}>
      <div
        className={styles.filler}
        css={css`
          width: ${completed}%;
          height: 100%;
          background-color: #4cb1d9;
          `}
        >
      </div>
    </div>
  )
};

export default ProgressBar;
